import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
	standalone: false,
	selector: 'external-svg',
	template: `
		<div>
			<div class="svg" *ngIf="svgData" [innerHTML]="svgData"></div>
		</div>
	`,
	styleUrls: ['../Css/Components/externalSvg.scss'],
	encapsulation: ViewEncapsulation.Emulated,
})
export class ExternalSvgComponent implements OnInit {
	private static REGEX_TO_REMOVE_RANDOM_COLOR_MODIFIERS_IN_A_SVG = /(fill|class|style)="(.*?)"/g;

	@Input() public imgSrc: string | null = null;
	public svgData: SafeHtml | null = null;

	constructor(private readonly domSanitizer: DomSanitizer) {
		// Empty
	}

	ngOnInit() {
		if (!this.imgSrc) throw new Error('imgSrc needs to be set');

		// Copied from, good job whoever wrote that:
		// https://github.com/VisibaCare/Visiba-Care-Service/blob/master/src/VisibaCare.Web/Public/src/app/Services/api/v2/Units/webContentButtons.service.ts#L41
		//
		// The seems to be the most the most convenient way to avoid any cors
		// issues or data getting flagged as "opaque".
		// https://media.giphy.com/media/1hAxQTH0HEWS3L0oRF/giphy.gif
		const xhr = new XMLHttpRequest();
		xhr.open('GET', this.imgSrc, true);
		xhr.withCredentials = false;
		xhr.send(null);
		xhr.onreadystatechange = () => {
			// In local files, status is 0 upon success in Mozilla Firefox
			if (xhr.readyState === XMLHttpRequest.DONE) {
				const cleansedOfCustomColor = xhr.responseText.replace(
					ExternalSvgComponent.REGEX_TO_REMOVE_RANDOM_COLOR_MODIFIERS_IN_A_SVG,
					'',
				);
				this.svgData = this.domSanitizer.bypassSecurityTrustHtml(cleansedOfCustomColor);
			}
		};
	}
}
